import { generateId, isObject } from 'Utils/common';
import store from 'Store';
import { httpClientUser } from './microservice-http-clients';

const id = generateId();

export const register = model => (
  httpClientUser.post('/register', model)
);
export const user = ({ email, password }) => (
  httpClientUser.post('/login', { email, password })
);
export const userLog = (action, data = '') => {
  // prevent send password to log
  if (JSON.stringify(data).includes('password')) return Promise.resolve();
  if (isObject(data)) Object.assign(data, { email: store['profile/profileEmail'] || '' });
  return httpClientUser.post('/auth0-debug',
    { action, data, side: 'front-end', id },
    { headers: { Authorization: '' } },
  )
    .catch((ignore) => {}) // eslint-disable-line
};
export const userEmailVerified = () => httpClientUser.post('/email-verified');
// Using in gtm "Affiliate software tracking" tag
window.debugAuthProcess = userLog;
